import React from "react";
import Badge from "./Badge";
import { getLabel } from "../InitData";
import Img from "./Img";

export default function WidgetWrapper(props) {
    const event = props.data;

    return (
        <div className="c_39">
            <div className="c_39_1">
                <Img className="c_39_1_1" src="icon_stats.svg" height="16px" width="16px" />
                <div className="c_39_1_2">
                    {event.isLive ?
                        <Badge desc={getLabel('general.live')} noMargin={true} />
                        :
                        <div className="c_39_1_2_1">{event.date} - {event.time}</div>
                    }
                    <div className="c_39_1_2_2">{event.desc}</div>
                </div>
                <Img className="c_39_1_3" src="icon_close.svg" height="32px" width="32px" onClick={props.close} />
            </div>
            <div className="c_39_2">
                {props.children}
            </div>
        </div>
    );
}
